import React, { useState } from "react";

export default ({ onClick, isRed, isActive }) => {

    if (typeof document !== "undefined") {
        const isNoScroll = document.body.classList.contains("u-no-scroll");
        if ((isActive && !isNoScroll) || (!isActive && isNoScroll)) {
            document.body.classList.toggle("u-no-scroll");
        }
    }

    return (
        <button className="m-menu-toggle" onClick={ onClick }>
            <span className={
                "m-menu-toggle__bars" +
                (isRed ? " m-menu-toggle__bars--red" : "") +
                (isActive ? " m-menu-toggle__bars--open" : "")
            }/>
        </button>
    );
}
